import React, { useRef } from "react";

import { Container, Row, Col } from "reactstrap";
import { Link, NavLink } from "react-router-dom";
import "../../styles/header.css";

const navLinks = [
  {
    path: "/home",
    display: "Home",
  },
  {
    path: "/about",
    display: "About",
  },
  {
    path: "/cars",
    display: "Hire Car",
  },
  {
    path: "/lease",
    display: "Lease Car",
  },
  {
    path: "/transfers",
    display: "Transfers",
  },
  {
    path: "/tours",
    display: "Tours",
  },
  {
    path: "/blogs",
    display: "Blog",
  },
  {
    path: "/contact",
    display: "Contact",
  },
];

const Header = () => {
  const menuRef = useRef(null);

  const toggleMenu = () => menuRef.current.classList.toggle("menu__active");

  return (
    <header className="header">
      {/* =============== header middle =========== */}
      <div className="header__middle">
        <Container>
          <Row>
            <Col lg="3" md="3" sm="4">
              <div className="logo">
                <h1>
                  <Link to="/home" className="d-flex align-items-center gap-2">
                    <img
                      src="/img/logo.png"
                      alt="logo"
                      style={{ maxWidth: "250px", maxHeight: "300px" }}
                    />
                    {/* <span>
                      Sankhu Car Rental <br /> and Tours
                    </span> */}
                  </Link>
                </h1>
              </div>
            </Col>

            <Col lg="4" md="3" sm="4">
              <div className="header__location d-flex align-items-center gap-2">
                <span>
                  <i class="ri-earth-line"></i>
                </span>
                <div className="header__location-content">
                  <h4>Hurlingham Plaza, Argwings Kodhek. Nairobi, Kenya.</h4>
                  <h6>2nd Floor Rm C14.</h6>
                </div>
              </div>
            </Col>

            <Col lg="2.5" md="3" sm="4">
              <div className="header__location d-flex align-items-center gap-2">
                <span>
                  <i class="ri-time-line"></i>
                </span>
                <div className="header__location-content">
                  <h4>Monday to Saturday</h4>
                  <h6>8am - 6pm</h6>
                </div>
              </div>
            </Col>

            <Col
              lg="2"
              md="3"
              sm="0"
              className=" d-flex align-items-center justify-content-center "
            >
              <button className="header__btn btn ">
                <Link to = "tel:+254113474733">
                  <i class="ri-phone-line"></i> Call us now
                </Link>
              </button>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ========== main navigation =========== */}

      <div className="main__navbar">
        <Container>
          <div className="header__mobile">
            <div className="navigation__wrapper d-flex align-items-center justify-content-between">
              <span className="mobile__menu">
                <i class="ri-menu-line" onClick={toggleMenu}></i>
              </span>
              
              <div className="navigation" ref={menuRef} onClick={toggleMenu}>
                <div className="menu">
                <img
                        className = "mobile__menu"
                        src="/img/logo.png"
                        alt="logo"
                        style={{ maxWidth: "70px", maxHeight: "70px" }}
                      />
                  {navLinks.map((item, index) => (
                    <NavLink
                      to={item.path}
                      className={(navClass) =>
                        navClass.isActive
                          ? "nav__active nav__item"
                          : "nav__item"
                      }
                      key={index}
                    >
                      {item.display}
                    </NavLink>
                  ))}
                </div>
              </div>

              <div className="nav__right">
                <div className="search__box">
                  <input type="text" placeholder="Search" />
                  <span>
                    <i class="ri-search-line"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="mobile__menu">
              <span className="mobile__header">
                <div className="logo">
                  <h1>
                    <Link
                      to="/home"
                      className="d-flex align-items-center gap-2"
                    >
                      <img
                        src="/img/logo2.png"
                        alt="logo"
                        style={{ maxWidth: "500px", maxHeight: "60px" }}
                      />
                      {/* <span>
                        Sankhu Car Rental <br /> and Tours
                      </span> */}
                    </Link>
                  </h1>
                </div>
              </span>
            </div>
          </div>
        </Container>
      </div>
    </header>
  );
};

export default Header;
